import { RadioChannelType } from "../../radio/data/RadioChannel";
import { InputData } from "../../../../library-js/php/input/InputData";

export class RadioInfoInput extends InputData
{
  weekday:string;
  time:string;
  channel:RadioChannelType;
  search:string;
}